export const FEATURE_FLAGS = {
  PERMISSION: {
    NEW_SUBSCRIPTION_MODAL: 'EnableNewSubscriptionModal',
    DEADLINES: 'DEADLINES',
    DEADLINE_SURVEY_PERM: 'DEADLINE_SURVEY_PERM',
    LAWSUIT_MONITORING: 'LawsuitMonitorPreview',
    PREVIEW_CALCULATION: 'PreviewCalculation',
    GDC_PERM: 'GDC_PERM',
    REPROCESS_BULK_QUERY: 'REPROCESS_BULK_QUERY',
    ENABLE_SUBUSER_CREATION: 'enableSubuserCreation',
    /**
     * Planejamento previdenciário no JusGPT legado (/gpt). O nome é o MESMO que
     * o juschat-backend consulta no featureflag-service: lá a flag força o chat
     * pro serviço novo, que calcula. Aqui ela só libera a entrada com
     * `context.calcSeed` — o backend confere de novo.
     *
     * Consumir com `useUserFeatureFlag`: a liberação é por user_id.
     */
    JUSGPT_PLANEJAMENTO_PREVIDENCIARIO: 'JusGPTPlanejamentoPrevidenciario',
  },
  KILL_SWITCH: {
    JUSMATCH_UPGRADE_CHECKOUT: 'JusmatchUpgradeCheckout',
    LAWSUIT_MONITOR_STEPS: 'LawsuitMonitorSteps',
    LAWSUIT_MONITOR_LAWSUITS: 'LawsuitMonitorLawsuits',
    LAWSUIT_MONITOR_DEADLINES: 'LawsuitMonitorDeadlines',
    LAWSUIT_MONITOR_ATTACHMENTS: 'LawsuitMonitorAttachments',
    LAWSUIT_MONITOR_ON_THE_FLY: 'LawsuitMonitorOnTheFly',
    ASYNC_SOCKET_CHANNEL: 'enableAsyncSocketChannel',
    ENABLE_CHECKOUT_ADDRESS: 'enableCheckoutAddress',
    ENABLE_CEP_AUTOFILL: 'enableCheckoutCepAutoFill',
    ENABLE_CHECKOUT_CUSTOMER_CREATE: 'enableCustomerAutoCreationOnCheckout',
    DEADLINES_NEW_MENU: 'DEADLINES_NEW_MENU',
    DEADLINE_SURVEY_KS: 'DEADLINE_SURVEY_KS',
    DEADLINE_CALENDAR_VIEW: 'DEADLINE_CALENDAR_VIEW',
    PAGARMEV5_CARD_TOKEN: 'ProviderGetTokenPagarmeV5',
    ENABLED_BANNER_UNIVERSAL_MIGRATION: 'EnabledBannerUniversalMigration',
    LAWSUIT_FILTER_DRAWER_KS: 'LAWSUIT_FILTER_DRAWER_KS',
    LAWSUIT_FILTER_DRAWER_STEP_INPUT_KS: 'LAWSUIT_FILTER_DRAWER_STEP_INPUT_KS',
    ENABLE_REQUEST_ADDRESS: 'enableRequestAddress',
    ENABLE_ADD_CARD_SENTRY: 'enableAddCardSentry',
    JUSPROCESSOS_LAWSUITS_SYNC_STATUS_KS:
      'JUSPROCESSOS_LAWSUITS_SYNC_STATUS_KS',
    ENABLE_PIX_PAYMENT_ON_CHECKOUT_FAILED: 'enablePixPaymentOnCheckoutFailed',
    LAWSUIT_FOLDERS_KS: 'LAWSUIT_FOLDERS_KS',
    USE_PLAN_ID_FROM_CLIENT: 'UsePlanIdFromClient',
    ENABLE_ORGANIC_MIGRATION: 'enableOrganicMigration',
    KS_ALL_FILTERS_OAB: 'KS_ALL_FILTERS_OAB',
    UNAVAILABLE_VEHICLE_DEBITS: 'unavailable_vehicle_debits',
    UNAVAILABLE_FINANCED_PROPERTIES: 'enable-financed_properties',
    UNAVAILABLE_LAWSUIT: 'unavailable_lawsuit',
    ENABLE_CUSTOMER_DASHBOARD_TRIAGE: 'EnableCustomerDashboardTriage',
    ENABLE_NEW_DASHBOARD: 'EnableNewDashboard',
    DISABLE_JUSSIGN_NEW_DOC: 'DisableJusSignNewDoc',
    ENABLE_CREDIT_CARD_REGULARIZATION: 'EnableCreditCardRegularization',
    ENABLE_WHATSAPP_CANCELLATION_SUPPORT: 'EnableWhatsAppCancellationSupport',
    ENABLE_FIRST_ACCESS_FLOW: 'EnableFirstAccessFlow',
    ENABLE_JUSSUB_CHECKOUT: 'enableJussubCheckout',
    ENABLE_SUBSCRIPTION_OR_CREDITS_FLOW: 'EnableSubscriptionOrCreditsFlow',
    DISABLE_CONSUME_DEPRECATED_ME_ENDPOINT:
      'DisableConsumeDeprecatedMeEndpoint',
    DISABLE_CONSUME_DEPRECATED_SUBSCRIPTIONS_ENDPOINT:
      'DisableConsumeDeprecatedSubscriptionsEndpoint',
    ENABLE_NEW_PRICING_TIERS_2026: 'EnableNewPricingTiers2026',
    ENABLE_PREVIEW_TO_ONE_COMMUNICATION: 'EnablePreviewToOneCommunication',
    ENABLE_SUBUSER_READ_ONLY_MODE: 'EnableSubuserReadOnlyMode',
    FRONT_JUSSUB_PLAN_AND_PAYMENTS_SHOW_BENEFTIS:
      'FrontJussubPlanAndPaymentsShowBenefits',
    ANTECIPACAO_PROCESSOS: 'AntecipacaoProcessos',
  },
  RELEASE: {
    NEW_ONBOARDING: 'NewOnboarding',
    JUSTRACKER_OAB_MONITORING: 'JUSTRACKER_OAB_MONITORING',
    JUSFINDER_QUERIES_FILTERS: 'JUSFINDER_QUERIES_FILTERS',
    JUSPROCESSOS_CAA_UPGRADE_FLOW: 'JusProcessosCaaUpgradeFlow',
    GAMIFICATION: 'GAMIFICATION',
    MGM_ENABLED: 'MgmEnabled',
    UPSELL_OAB_MG: 'UpsellOabMG',
    REACTIVATION_SINGLE_PLAN: 'ReactivationSinglePlan',
    MGM_DASH_TASK_CARD: 'MgmDashTaskCard',
    FEATURE_OFFER_BANNER: 'EnableFeatureOfferBanner',
    JURISPRUDENCIA: 'EnableJurisprudencia',
    CANCEL_FLOW_RETENTION_OFFER: 'CancelFlowRetentionOffer',
    AFFILIATES: 'EnableAffiliates',
    JUSAGENDA_MIGRATED: 'JusagendaMigrated',
    INSTAGRAM_CREATOR: 'InstagramCreator',
    // Criador de Conteúdo (ferramenta + LP). Release por user_id, avaliada com
    // perUser/useUserFeatureFlag; sem ela o item some do menu e a rota
    // /criador-de-conteudo vai para /dashboard. O NOVO com shimmer de Clientes
    // aparece para todos, só pela janela de noveltyDate.
    INSTAGRAM_CREATOR_LP: 'InstagramCreatorLp',
    // Plano academy (aluno): menu e dash do JusRecruta. Release por user_id,
    // avaliada com useUserFeatureFlag; anda junto com REACT_APP_ACADEMY_PLAN_IDS
    // (ver hooks/useIsAcademyUser).
    ACADEMY: 'EnableAcademy',
    // Troca Academy ⇄ Jusfy para o aluno que também é advogado. Liberada na
    // mão, por user_id, no Unleash (ver hooks/useIsAcademyUser).
    ACADEMY_SWITCH: 'EnableAcademySwitch',
    /**
     * JusScore RH. O nome é o MESMO da flag do jusfy-backend
     * (`FEATURE_FLAG.JUS_SCORE_RH`), que responde 404 nas rotas do módulo
     * enquanto ela está desligada: duas flags para o mesmo rollout deixariam a
     * tela aberta contra uma API fechada.
     */
    JUSCORE_RH: 'JusScoreRh',
    /**
     * JusScore (card no Jusfinder). Flag PRÓPRIA, separada de `JusScoreRh`: os
     * dois módulos são liberados para públicos diferentes. O nome é o mesmo da
     * flag do jusfy-backend (`FEATURE_FLAG.JUS_SCORE`), que responde 404 em
     * `/api/jus-score` enquanto ela está desligada.
     *
     * Consumir com `useUserFeatureFlag`, não `useFeatureFlag`: a allowlist no
     * Unleash é por user_id e o `is-enabled` sem contexto esconderia o card
     * justamente de quem foi liberado.
     */
    JUSCORE: 'JusScore',
    CUSTOMER_FINANCE_TAB: 'EnableCustomerFinanceTab',
    /**
     * Teste A/B do endereço do step 2 do checkout (`/register`): só o CEP no começo,
     * resumo depois da busca. Flag de VARIANTE (`control` | `compact`), lida com
     * `getVariantDirectly` e contexto `sessionId` — não com `useFeatureFlag`.
     * Ver `pages/Cadastro/experiment/compactAddressExperiment.ts`.
     */
    CHECKOUT_COMPACT_ADDRESS_EXPERIMENT: 'CheckoutCompactAddressExperiment',
    /**
     * Teste A/B do card "Sua oferta" no `/register`: entre quem
     * já seria elegível ao card, o braço `control` fica sem ele. Flag de VARIANTE
     * (`control` | `offer`), contexto `sessionId`. Ver
     * `pages/Cadastro/experiment/offerCardExperiment.ts`.
     */
    CHECKOUT_OFFER_CARD_EXPERIMENT: 'CheckoutOfferCardExperiment',
    // Auth 2.0 Centralizado
    ENABLE_NEW_AUTH_SERVICE: 'EnableNewAuthService',
    /**
     * JusCalc Precatórios (`/precatorios`). Lida POR USUÁRIO
     * (`useUserFeatureFlag` / `WithFeatureFlag` com `perUser`), porque a
     * estratégia no Unleash é allowlist por `userId`, como o JusScore: a
     * consulta global (`is-enabled`) não manda contexto e esconderia a tela de
     * quem foi liberado. Desligada: a rota redireciona para /calculadoras e o
     * card some da lista. O back (`POST /reports/precatorio`) não depende dela.
     */
    JUSCALC_PRECATORIOS: 'JUSCALC_PRECATORIOS',
    /**
     * RMC V2: Passo 3 novo com os oito blocos (FT-2999 / FT-3007). O nome é o
     * MESMO da flag do jusfy-backend, que responde 403 `FEATURE_NAO_LIBERADA`
     * em `POST /api/rmc/v2` enquanto ela está desligada para o cliente. Lida
     * POR USUÁRIO (`useUserFeatureFlag`), como Precatórios: a liberação é por
     * cliente. Desligada, a RMC segue no V1 (`POST /rmc`), sem mudança.
     */
    JUSCALC_RMC_V2: 'JusCalcRmcV2',
    JUSMATCH_V2: 'JusMatchV2',
  },
} as const;

export const FEATURE_FLAG_TYPES = {
  KILL_SWITCH: 'killSwitch',
  PERMISSION: 'permission',
  RELEASE: 'release',
} as const;

export type PermissionFeatureFlag = typeof FEATURE_FLAGS.PERMISSION[keyof typeof FEATURE_FLAGS.PERMISSION];

export type KillSwitchFeatureFlag = typeof FEATURE_FLAGS.KILL_SWITCH[keyof typeof FEATURE_FLAGS.KILL_SWITCH];

export type ReleaseFeatureFlag = typeof FEATURE_FLAGS.RELEASE[keyof typeof FEATURE_FLAGS.RELEASE];

export type FeatureFlagName =
  | PermissionFeatureFlag
  | KillSwitchFeatureFlag
  | ReleaseFeatureFlag;

export type FeatureFlagType = typeof FEATURE_FLAG_TYPES[keyof typeof FEATURE_FLAG_TYPES];
